import { Messages } from '../../../../codegen/Localize';
import { IExplorableItemTypeInfo, IItemStatisticsInfo,ILuidItemInfo } from '../../../../ts/models/resourceInfoParts';
import { IViewUsageInfo } from '../../../../ts/ServerApi/types/IUsageInfo';

export interface IWorkbookAccelerationInfo extends
ILuidItemInfo,
IItemStatisticsInfo<IViewUsageInfo>,
IExplorableItemTypeInfo {
  path: string;
  index: number;
  speedUp: number;
  avgNonAcceleratedPLT: number;
  avgAcceleratedPLT: number;
  isAccelerated: boolean;
  optimizationNotes: Map<string, number>;
}

export namespace IWorkbookAccelerationInfo {
  export function getLocalizedDataAccelerationOptimizatioNote(note: string): string {
    switch (note) {
      case 'query-transient': return Messages.optiNoteQueryTransient();
      case 'query-has-user-reference': return Messages.optiNoteQueryHasUserReference();
      case 'query-uses-has-top-with-percentage': return Messages.optiNoteQueryHasTopWithPercentage();
      case 'query-shape-simple': return Messages.optiNoteQueryShapeSimple();
      case 'query-has-spatial-data': return Messages.optiNoteQueryShapeSimple();
      case 'query-large': return Messages.optiNoteQueryLarge();
      case 'query-result-reduction-not-enough': return Messages.optiNoteQueryResultReductionNotEnough();
      case 'query-result-large': return Messages.optiNoteQueryResultLarge();
      case 'query-exe-shorter-than-insertion': return Messages.optiNoteQueryExeShorterThanInseration();
      case 'query-fast': return Messages.optiNoteQueryFast();
      case 'multi-conn-query-not-generated-via-aql': return Messages.optiNoteMultiConnQueryNotGeneratedViaAql();
      case 'object-model-query-not-supported': return Messages.optiNoteObjectModelQueryNotSupported();
      case 'eqc-above-cache-size-limit': return Messages.optiNoteEqcAboveCacheSizeLimit();
      case 'eqc-fast': return Messages.optiNoteEqcFast();
      case 'eqc-large-data': return Messages.optiNoteEqcLargeData();
      case 'eqc-large-key': return Messages.optiNoteEqcLargeKey();
      default:
        throw new Error('unknow data acceleration optimization note for localizing: ' + note);
    }
  }
}
